import Image from 'next/image'
import { SearchInputProps } from '@interfaces/header'
import { Button } from '@components/Ackodrive/Button'
import styles from './SearchComponent.module.scss'
import { CHEVRON_LEFT_LIGHT, CIRCULAR_CLOSE, SEARCH } from '../constants/icons'

const SearchInput = ({
  variant,
  searchQuery,
  onSearch,
  onClear,
  onBack,
  onFocus,
  onKeyPress,
  isFocused,
  inputRef,
}: SearchInputProps) => (
  <>
    {variant === 'mobile' && onBack && (
      <Button onClick={onBack} className={styles.backButton}>
        <Image src={CHEVRON_LEFT_LIGHT} alt="Back" loading="lazy" width={24} height={24} />
      </Button>
    )}

    <input
      ref={inputRef}
      type="text"
      className={styles.searchInput}
      placeholder={variant === 'desktop' ? 'Search for cars...' : 'What are you looking for?'}
      value={searchQuery}
      onChange={e => {
        onSearch(e.target.value)
      }}
      onFocus={onFocus}
      onKeyPress={onKeyPress}
    />

    {variant === 'desktop' ? (
      !searchQuery ? (
        <Image src={SEARCH} alt="Search" width={20} height={20} loading="lazy" />
      ) : (
        <Image
          src={CIRCULAR_CLOSE}
          alt="Clear"
          width={16}
          height={16}
          onClick={onClear}
          className={styles.clearIcon}
          loading="lazy"
        />
      )
    ) : (
      searchQuery && (
        <Button onClick={onClear} className={styles.clearButton}>
          <Image src={CIRCULAR_CLOSE} alt="Clear" width={20} height={20} loading="lazy" />
        </Button>
      )
    )}
  </>
)

export default SearchInput
